export default __webpack_public_path__ + "static/media/sealife7.92df00dc.jpg";